import React from 'react';
import logo from '../../assets/ioLiberum-Primary_Logo-On_Navy.svg';

/**
 * ioLiberum brand header — navy background with orange brand mark.
 * Consistent across all surfaces.
 */
export default function Header({ onSettingsClick, onDashboardClick, onTriageClick, onAdminClick, isAdmin }) {
    return (
        <div className="addin-header">
            <div className="brand">
                <img src={logo} alt="ioLiberum Logo" className="login-logo" />
            </div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                {isAdmin && (
                    <div
                        className="nav-icon"
                        title="User Management"
                        onClick={onAdminClick}
                        style={{ cursor: 'pointer', padding: '4px', fontSize: '15px' }}
                    >
                        👥
                    </div>
                )}
                <div
                    className="nav-icon"
                    title="Batch Triage"
                    onClick={onTriageClick}
                    style={{ cursor: 'pointer', padding: '4px', fontSize: '16px' }}
                >
                    ⚡
                </div>
                <div
                    className="nav-icon"
                    title="Dashboard"
                    onClick={onDashboardClick}
                    style={{ cursor: 'pointer', padding: '4px' }}
                >
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                        <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                    </svg>
                </div>
                <div
                    className="nav-icon"
                    title="Settings"
                    onClick={onSettingsClick}
                    style={{ cursor: 'pointer', padding: '4px' }}
                >
                    <svg viewBox="0 0 14 14" width="14" height="14">
                        <rect x="1" y="3" width="12" height="1.5" rx="0.75" fill="currentColor" />
                        <rect x="1" y="6.25" width="12" height="1.5" rx="0.75" fill="currentColor" />
                        <rect x="1" y="9.5" width="12" height="1.5" rx="0.75" fill="currentColor" />
                    </svg>
                </div>
            </div>
        </div>
    );
}
